const state = {
  widgetViewed: false,
  homeInLanding: false,
};

const mutations = {
  setwidgetViewed (state, value) {
    state.widgetViewed = value;
  },
  setHomeInLanding (state, value) {
    state.homeInLanding = value;
  },
};
const getters = {
  getwidgetViewed: state => state.widgetViewed,
  getHomeInLanding: state => state.homeInLanding,
};
const actions = {
  setwidgetViewed ({commit}, value) {
    commit ('setwidgetViewed', value);
  },
  setHomeInLanding ({commit}, value) {
    commit ('setHomeInLanding', value);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
